<!--
 * @Author: your name
 * @Date: 2020-04-03 14:52:28
 * @LastEditTime: 2020-04-03 15:29:07
 * @LastEditors: your name
 * @Description: In User Settings Edit
 * @FilePath: \gta_aitraining_vue\src\App.vue
 -->
<template>
  <div id="app">
    <!-- 所有页面加上回到顶部按钮 -->
    <el-backtop :visibility-height="150" :right="40" :bottom="40">
      <div
        style="{
          height: 100%;
          width: 100%;
          background-color: #f2f5f6;
          box-shadow: 0 0 6px rgba(0,0,0, .12);
          text-align: center;
          line-height: 40px;
          color: #1989fa;
        }"
      >
        <!-- UP -->
        <i class="el-icon-arrow-up"></i>
      </div>
    </el-backtop>
    
    <!-- :key="this.$route.path" 解决跳转到当前页面的缓存问题-->

    <keep-alive>
      <!-- 实训中心-实训详情页 实现页面缓存 -->
      <router-view v-if="$route.path.indexOf('cursedetails') !== -1" :key="this.$route.path" />
    </keep-alive>
    <router-view
      v-if="isRouterAlive && !($route.path.indexOf('cursedetails') !== -1)"
      :key="this.$route.path"
    />
    <!-- <router-view v-if="isRouterAlive" :key="this.$route.path" /> -->
    <gat-compatibility />
    <!-- <progress-model/> -->
  </div>
</template>

<script>
import GatCompatibility from '@/components/common/GatCompatibility'
// import progressModel from '@/components/common/progressModel'

export default {
  components: { GatCompatibility },
  metaInfo: {
    title: '国匠云人工智能应用软件',
    meta: [
      {
        name: 'keyWords',
        content: '国匠云人工智能应用软件,人工智能教学,人工智能通识课教育,图形化编程',
      },
      {
        name: 'description',
        content:
          'AI Training实训平台是针对中高职、应用型本科院校对人工智能通识教育教学与实训需求，提供积木可视化编程学习、python语言基础学习、python在线编辑器、AI算法模型积木可视化调用、提供Python语言的可视化编程、多类型数据标注、AI算法模型训练及调用、在线人工智能教学、行业应用项目实训等能力，满足人工智能相关教学与实训的有效开展。',
      },
    ],
  },
  provide() {
    return {
      reload: this.reload,
    }
  },
  data() {
    return {
      isRouterAlive: true,
    }
  },
  computed: {
    token() {
      return this.$store.state.token
    },
  },
  beforeCreate() {
    //  console.log('process.env.VUE_APP_TAG---222',process.env.VUE_APP_TAG)
    // console.log('Vue.prototype.$router',Vue.prototype.$router)
  },
  created() {
  
  },
  mounted(){

  },
  methods: {
    reload() {
      // 刷新页面处理
      this.isRouterAlive = false
      this.$nextTick(() => {
        this.isRouterAlive = true
      })
    },
  },
}
</script>

<style lang="scss">
html,
body {
  height: 100%;
  min-width: $min_width;
}
#app {
  height: 100%;
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  // text-align: center;
  // color: #2c3e50;
}
</style>
